import React from 'react';
import { useTranslation } from 'react-i18next';
import { Edit, X } from 'lucide-react';

const MailRenameFolderModal = ({
  renameFolder,
  renameFolderName,
  setFolderToRename,
  setRenameFolderName,
  setShowRenameFolderModal
}) => {
  const { t } = useTranslation('admin');
  return (
    <>
        <div data-testid="mail-rename-folder-modal" className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm">
            <div className="p-6 border-b border-slate-200">
              <div className="flex items-center justify-between">
                <h3 className="text-lg font-bold text-slate-900 flex items-center">
                  <Edit size={20} className="mr-2 text-purple-600" />
                  {t('mail.renameFolderTitle')}
                </h3>
                <button
                  data-testid="mail-rename-folder-close"
                  onClick={() => {
                    setShowRenameFolderModal(false);
                    setFolderToRename(null);
                    setRenameFolderName('');
                  }}
                  className="p-2 hover:bg-slate-100 rounded-full transition-colors"
                >
                  <X size={20} className="text-slate-500" />
                </button>
              </div>
            </div>
            <div className="p-6">
              <input
                type="text"
                data-testid="mail-rename-folder-input"
                value={renameFolderName}
                onChange={(e) => setRenameFolderName(e.target.value)}
                placeholder={t('mail.newNamePlaceholder')}
                className="w-full px-4 py-3 border border-slate-200 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                autoFocus
                onKeyDown={(e) => {
                  if (e.key === 'Enter') renameFolder();
                }}
              />
            </div>
            <div className="p-6 pt-0 flex justify-end space-x-3">
              <button
                onClick={() => {
                  setShowRenameFolderModal(false);
                  setFolderToRename(null);
                  setRenameFolderName('');
                }}
                className="px-4 py-2 text-slate-600 hover:bg-slate-100 rounded-xl transition-colors"
              >
                {t('mail.cancelBtn')}
              </button>
              <button
                data-testid="mail-rename-folder-submit"
                onClick={renameFolder}
                disabled={!renameFolderName.trim()}
                className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {t('mail.rename')}
              </button>
            </div>
          </div>
        </div>
    </>
  );
};

export default MailRenameFolderModal;
